import { Navigate } from 'react-router-dom';

/** Keep saved links usable after task results move into the shared Tasks page. */
export function MissionPage() {
  return <Navigate to="/tasks" replace />;
}
